import { useMemo } from 'react';
import { Dropdown, DropdownOption } from '@hawkins/components';
import { descriptiveAspectRatioLookup } from 'src/domains/api/static';

interface AspectRatioDropdownProps {
  disabled: boolean;
  value?: DropdownOption<number> | null;
  onChange: (selected: DropdownOption<number> | null) => void;
  calculatedValue?: number | null;
  isCalculated?: boolean;
  isLocked?: boolean;
}

export const AspectRatioDropdown = ({
  disabled,
  value,
  onChange,
  calculatedValue,
  isCalculated = false,
  isLocked = false,
}: AspectRatioDropdownProps) => {
  const displayValue = useMemo(() => {
    if (
      isCalculated &&
      calculatedValue !== null &&
      calculatedValue !== undefined &&
      !isLocked
    ) {
      return {
        label: `${calculatedValue.toFixed(2)} : 1 (Calculated)`,
        value: calculatedValue, // Keep precise value for calculations
      };
    }

    // For non-calculated modes, use the form value
    return value;
  }, [isCalculated, calculatedValue, isLocked, value]);

  return (
    <Dropdown
      creatable
      searchable={!disabled}
      dropdownWidthType="full"
      disabled={disabled}
      label={'Aspect Ratio'}
      onChange={(newValue) => {
        if (newValue?.value && !isNaN(newValue.value)) {
          onChange(newValue);
        }
      }}
      onCreateOption={(inputValue) => {
        const parsedValue = parseFloat(inputValue);
        if (!isNaN(parsedValue)) {
          const label = `${parsedValue} : 1 (Custom)`;
          return {
            label,
            value: parsedValue,
          };
        }
      }}
      options={descriptiveAspectRatioLookup}
      value={displayValue}
    />
  );
};
